(function ($) {
  'use strict';

  window.ys.StravaUci23 = new StravaUci23();
  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('strava_uci23')) {
    window.ys.StravaUci23Contest = new StravaUci23.Contest();
  }
}).bind(window)(jQuery);
